export const DropdownIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.5246 15.8824C11.7647 16.1944 12.2353 16.1944 12.4754 15.8824L16.4525 10.716C16.7562 10.3215 16.475 9.75 15.9771 9.75H8.02292C7.52501 9.75 7.24375 10.3215 7.54747 10.716L11.5246 15.8824Z"
        fill="currentColor"
      />
    </svg>
  );
};
